<!-- Error Views -->
<app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
<!-- Content -->
<div class="gridItemChildModule w-100 h-100 d-flex flex-column" *ngIf="dataLoadSuccess && !noData">
    <!--Search-->
    <div class="d-flex flex-column">
        <div class="cxone-live-search ml-2 my-2" *ngIf="showFilter && !noData">
            <cxone-text-input
                type="search"
                autocomplete="off"
                class="cxone-widget-search"
                [placeholder]="searchPlaceholder" 
                [(ngModel)]="this.filterValue"
                (ngModelChangeDebounced)="filterValue"
                [ngModelChangeDebounceTime]="500"
                (keyup)="applyFilter()"
                name="cxoneInput-{{moduleKey}}"
            ></cxone-text-input>
            <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
                <svg class="icon-18 fill-iconDefault-noHover cxone-search-wrapper">
                    <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                </svg>
            </i>
            <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
                <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
                    <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                </svg>
            </i>
        </div>
    </div>
    <!--Module content-->
    <div class="flex-fill d-flex" style="min-height: 0px">
        <ag-grid-angular #contactStatesSkillWidgetGrid *ngIf="gridOptions !== null && !noData" class="ag-theme-balham grid flex-fill" [gridOptions]="gridOptions"></ag-grid-angular>
        <div class="legendContainer" *ngIf="gridOptions !== null && !noData">
            <div class="legend">
                <div class="legendHeader" cvLocalizedText langSection="Contact_States_By_Skill" langKey="Legend">Legend</div>
                <div class="legendItem" *ngFor="let state of contactStates">
                    <div class="legendColor" [ngStyle]="{'background-color': getStateColor(state.baseName)}"></div>
                    <span class="legendText">{{ state.localizedName }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
